// src/utils/editorUtils.js

// Autocorrect functionality
export const checkSpelling = (text) => {
  // Mock implementation - replace with actual spellcheck library
  const commonMisspellings = {
    'teh': 'the',
    'adn': 'and',
    'thier': 'their',
    'wierd': 'weird',
    'recieve': 'receive'
  };

  const errors = [];
  const words = text.split(/\s+/);
  
  words.forEach((word, index) => {
    const cleanWord = word.replace(/[.,!?;:"]+$/, '').toLowerCase();
    if (commonMisspellings[cleanWord]) {
      errors.push({
        word,
        suggestion: commonMisspellings[cleanWord],
        position: text.indexOf(word),
        length: word.length
      });
    }
  });

  return {
    text,
    errors,
    hasErrors: errors.length > 0
  };
};

// Goal tracking utilities
export const calculateProgress = (goals) => {
  if (!goals || !goals.length) return 0;
  const completed = goals.filter(g => g.completed).length;
  return Math.round((completed / goals.length) * 100);
};

export const getDefaultMilestones = () => {
  return [
    { name: 'Drafting', days: 7, completed: false },
    { name: 'Revising', days: 5, completed: false },
    { name: 'Editing', days: 3, completed: false }
  ];
};

// Document statistics
export const getDocumentStats = (content) => {
  const words = content.trim() ? content.split(/\s+/).length : 0;
  const chars = content.length;
  const paragraphs = content.trim() ? content.split(/\n\n/).length : 0;
  
  return {
    words,
    chars,
    paragraphs,
    readingTime: Math.ceil(words / 200) // 200 wpm average
  };
};

// Formatting helpers
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};